import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance/axiosInstance";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import { AppReviewDemoStatusResponse } from "../contracts/AppReviewDemoStatusResponse";
import { PrepareAppReviewDemoRequest } from "../contracts/PrepareAppReviewDemoRequest";
import { mapResponseToAppReviewDemoStatus } from "../mappers/AppReviewDemoStatusMapper";
import { AppReviewDemoStatus } from "../models/AppReviewDemoStatus";

/** The App Review demo school's status (back office, PD-0053). */
export const fetchAppReviewDemo = createAsyncThunk<
  AppReviewDemoStatus,
  void,
  { rejectValue: ApiErrorResponse }
>("admin/fetchAppReviewDemo", async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get<AppReviewDemoStatusResponse>("/admin/app-review/demo");
    return mapResponseToAppReviewDemoStatus(response.data);
  } catch (error) {
    return rejectWithValue(toApiError(error, "Failed to load the App Review demo"));
  }
});

/** Creates the App Review demo school, or resets it to the same state. */
export const prepareAppReviewDemo = createAsyncThunk<
  AppReviewDemoStatus,
  PrepareAppReviewDemoRequest,
  { rejectValue: ApiErrorResponse }
>("admin/prepareAppReviewDemo", async (request, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post<AppReviewDemoStatusResponse>(
      "/admin/app-review/demo",
      request
    );
    return mapResponseToAppReviewDemoStatus(response.data);
  } catch (error) {
    return rejectWithValue(toApiError(error, "Failed to prepare the App Review demo"));
  }
});
